import * as Sentry from '@sentry/browser';

export const ApiCatchToSentry = (error, formName, getState, form) => {
    const { dynamicForms } = getState();
    const entry = dynamicForms?.formEntries?.entries?.find(
        (item) => item.structure.name === formName
    );
    const content = form?.content;
    const data = { errorMessage: error.message, formName, formEntryId: entry?.id, content };
    const storeStringify = JSON.stringify(data);

    Sentry.configureScope((scope) => {
        scope.setTag('formError', error.response.status);
        scope.setLevel('Error').setExtra('store', storeStringify);
    });

    return Sentry.captureException(error);
};
